/* eslint no-param-reassign: "off" */
import * as types from './mutation-types';

export default {
  [types.GENERATE_URL_REQUEST]: state => {
    state.loadingGenerateUrl = true;
    state.generateUrlFailed = false;
    state.generateUrlSuccess = false;
  },
  [types.GENERATE_URL_FAILED]: state => {
    state.loadingGenerateUrl = false;
    state.generateUrlFailed = true;
    state.generateUrlSuccess = false;
  },
  [types.GENERATE_URL_SUCCESS]: (state, payload) => {
    state.loadingGenerateUrl = false;
    state.generateUrlFailed = false;
    state.generateUrlSuccess = true;
    state.generatedUrl = payload;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/publishing/mutations.js